import styled from 'styled-components';
import { DescriptionText } from '@components/common/Modal/Modal.styles';
import Link from '@components/common/Link';

export const StyledDescription = styled(DescriptionText)`
  margin-bottom: 48px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledLink = styled(Link)`
  margin-right: 24px;
`;
